// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Tour/TourGalleryForm.jsx

import { OrderList } from 'primereact/orderlist';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// This component is now a "dumb" component. It only displays data and sends events up.
const TourGalleryForm = ({
  previewImages,
  handleImageRemove,
  handleUpdateSortOrder,
  handleImagesChange,
}) => {

  // FIXED: The itemTemplate signature is changed to only accept `image` to be more robust.
  const imageItemTemplate = (image) => {
    const displaySort = image.sort;

    return (
      <div className="d-flex align-items-center p-2 w-100">
        <span className="fw-bold me-3" style={{minWidth: '20px'}}>{displaySort}</span>
        <img
          src={image.url}
          alt={`Preview ${displaySort}`}
          style={{ width: '80px', height: '80px', objectFit: 'cover', marginRight: '1rem' }}
        />
        <div className="flex-grow-1 text-truncate">
          {/* You can add image name here if available */}
        </div>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm p-1"
          style={{ lineHeight: 1 }}
          // FIXED: Pass the entire `image` object back to the parent.
          onClick={() => handleImageRemove(image)}
        >
          <i className="pi pi-trash" />
        </button>
      </div>
    );
  };

  return (
    <div>
      <label htmlFor="galleryInput" className="form-label">Upload Images:</label>
      <input
        type="file"
        className="form-control"
        id="galleryInput"
        multiple
        onChange={handleImagesChange}
        accept="image/*"
      />

      {previewImages && previewImages.length > 0 && (
        <div className="mt-3">
            <OrderList
                value={previewImages}
                itemTemplate={imageItemTemplate}
                onChange={handleUpdateSortOrder}
                listStyle={{ maxHeight: '700px' }}
                header="Image Gallery"
                dragdrop
            />
        </div>
      )}
    </div>
  );
};

export default TourGalleryForm;